"use client"
import { BlogDigest } from "@/components/terra/layouts/BlogDigest/BlogDigest"

// eslint-disable-next-line no-restricted-imports -- wrapped in <Suspense> by FormatBlogDigest, its only caller
import { usePathname, useRouter, useSearchParams } from "next/navigation"

export const BlogDigestWrapper = (formattedBlogDigest: any) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const handleSearch = (value: string) => {
    const params = new URLSearchParams(searchParams?.toString() || "")
    params.set("search", value)
    if (formattedBlogDigest?.searchFilter) {
      params.set("searchFilter", formattedBlogDigest.searchFilter)
    }
    router?.push(`${pathname}?${params.toString()}`)
  }

  const digestInput = {
    ...formattedBlogDigest,
    onSearch: formattedBlogDigest?.showSearch ? handleSearch : undefined,
  }

  return <BlogDigest {...digestInput} />
}
